// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'http://localhost:4200',
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  firebaseConfig: {
    apiKey: "AIzaSyCxFx1tidOXqyO49e-z7qo_qxVfXGkyM9k",
    authDomain: "ekasi-app.firebaseapp.com",
    databaseURL: "https://ekasi-app.firebaseio.com",
    projectId: "ekasi-app",
    storageBucket: "ekasi-app.appspot.com",
    messagingSenderId: "786303364339",
    appId: "1:786303364339:web:9e4becab98635b0e459b86",
    measurementId: "G-MGWVJ7YCMN"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
